import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown, Download } from 'lucide-react';

export interface PlanogramExportMenuProps {
  onExport: (audience: 'internal' | 'external') => void;
  disabled?: boolean;
}

export function PlanogramExportMenu({ onExport, disabled = false }: PlanogramExportMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled}>
          <Download className="mr-2 h-4 w-4" />
          Export Excel
          <ChevronDown className="ml-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[16rem]">
        <DropdownMenuItem
          className="flex-col items-start gap-0.5"
          onClick={() => onExport('internal')}
        >
          <span>Internal</span>
          <span className="text-xs text-muted-foreground">
            Includes images, cost, sell price, listing fee, and margin
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex-col items-start gap-0.5"
          onClick={() => onExport('external')}
        >
          <span>External</span>
          <span className="text-xs text-muted-foreground">
            Images, slot number, products, and sell price — no cost or margin
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
